"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Pagination = _interopRequireDefault(require("../../Pagination/Pagination"));
var _Paginator = _interopRequireDefault(require("../../../common/Paginator"));
var _Filters = _interopRequireWildcard(require("./Filters"));
var _Dropdown = _interopRequireDefault(require("../../Dropdown/Dropdown"));
var _EventOccurrenceList = _interopRequireDefault(require("../../EventOccurrenceList/EventOccurrenceList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-agenda {\n  padding-inline: 0px; }\n  .sia-agenda .bx--list-box__menu {\n    visibility: visible !important; }\n  .sia-agenda .filter-container {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    column-gap: 16px;\n    row-gap: 0px; }\n  .sia-agenda .sort-container {\n    display: flex;\n    justify-content: center; }\n    .sia-agenda .sort-container .sort {\n      width: max-content;\n      margin-bottom: 1rem; }\n      .sia-agenda .sort-container .sort label {\n        color: #a8a8a8; }\n  .sia-agenda .name-search {\n    position: relative; }\n    .sia-agenda .name-search svg {\n      position: absolute;\n      right: 8px;\n      top: 32px;\n      cursor: pointer; }\n    .sia-agenda .name-search label {\n      opacity: 0; }\n    .sia-agenda .name-search input {\n      padding-right: 42px; }\n\n@media (max-width: 66rem) {\n  .sia-agenda {\n    padding-inline: 16px; }\n    .sia-agenda .filter-container {\n      grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n\n@media (max-width: 42rem) {\n  .sia-agenda .filter-container {\n    grid-template-columns: repeat(1, minmax(0, 1fr)); } }\n";
  const fileName = "SIAAgenda_SIAAgenda";
  const element = document.querySelector("style[data-sass-component='SIAAgenda_SIAAgenda']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAAgenda = _ref => {
  let {
    history,
    lang,
    translate,
    getAgenda,
    onClick
  } = _ref;
  const location = history.location;
  const [page, setPage] = (0, _react.useState)(1);
  const [itemsPerPage, setItemsPerPage] = (0, _react.useState)(10);
  const [eventsOccurrence, setEventsOccurrence] = (0, _react.useState)([]);
  const [filteredEventsOccurrence, setFilteredEventsOccurrence] = (0, _react.useState)([]);
  const query = new URLSearchParams(location.search);
  const defaultValues = (0, _Filters.getDefaultValues)(query);
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [name, setName] = (0, _react.useState)(defaultValues.name);
  const [filterItems, setFilterItems] = (0, _react.useState)({});
  const [filters, setFilters] = (0, _react.useState)({});
  const sortItems = [{
    id: 'oldest',
    label: translate('cms.agenda.sort.next'),
    method: (a, b) => a.date_seconds - b.date_seconds
  }, {
    id: 'newest',
    label: translate('cms.agenda.sort.last'),
    method: (a, b) => b.date_seconds - a.date_seconds
  }];
  const [sortItem, setSortItem] = (0, _react.useState)(sortItems[0]);
  (0, _react.useEffect)(() => {
    const method = sortItems.find(item => item.id === sortItem.id)?.method;
    if (method) {
      const aux = [...filteredEventsOccurrence];
      const sorted = aux.sort(method);
      setFilteredEventsOccurrence(sorted);
    }
  }, [sortItem]);
  const searchEventsOccurrence = () => {
    setIsLoading(true);
    getAgenda(data => {
      const event_occurrences = data.event_occurrences;
      setEventsOccurrence(event_occurrences);
      setFilteredEventsOccurrence(event_occurrences);
      setFilterItems((0, _Filters.getDefaultFiltersItemsValue)(data));
      setFilters((0, _Filters.getDefaultFiltersValue)(defaultValues));
      setIsLoading(false);
    });
  };
  (0, _react.useEffect)(() => {
    getAgenda && searchEventsOccurrence();
  }, []);
  (0, _react.useEffect)(() => {
    if (eventsOccurrence?.length > 0) {
      const newValue = (0, _Filters.getFilteredEventOccurrences)(eventsOccurrence, filters, name);
      const method = sortItems.find(item => item.id === sortItem.id)?.method;
      if (method) {
        newValue.sort(method);
      }
      setFilteredEventsOccurrence(newValue);
      setPage(1);
      const urlParams = (0, _Filters.getUrlParams)(filters, name);
      history.replace({
        pathname: location.pathname,
        search: decodeURIComponent(urlParams.toString())
      });
    }
  }, [filters, name]);
  const paginatedItems = filteredEventsOccurrence?.length > 0 ? _Paginator.default.paginateItems(filteredEventsOccurrence, page, itemsPerPage) : [];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-agenda"
  }, /*#__PURE__*/_react.default.createElement(_Filters.default, {
    defaultValues: defaultValues,
    translate: translate,
    filters: filters,
    filterItems: filterItems,
    filteredEventsOccurrence: filteredEventsOccurrence,
    setFilters: setFilters,
    setName: setName
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sort-container"
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    id: "sort",
    className: 'sort',
    items: sortItems,
    label: translate('sort.by'),
    value: sortItem,
    onChange: (event, item) => {
      setSortItem(item);
    },
    inline: true
  })), paginatedItems && paginatedItems?.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_EventOccurrenceList.default, {
    lang: lang,
    translate: translate,
    eventOccurrences: paginatedItems,
    onClick: onClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-12 sia-padding-02-top"
  }, /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    items: filteredEventsOccurrence,
    onChange: (newPage, perPageLimit) => {
      setPage(newPage);
      setItemsPerPage(perPageLimit);
    },
    translate: translate,
    page: page
  }))) : !isLoading && /*#__PURE__*/_react.default.createElement("h3", {
    className: "sia-text-12 sia-padding-05-bottom"
  }, translate('cms.catalog.empty')));
};
var _default = exports.default = SIAAgenda;